import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface Props {
  width?: number;
}

const defaultProps: Props = { width: 300 };

const Pane = styled(Box)<Props>`
  position: relative;
  display: flex;
  flex: 0 0 ${(props) => props.width ?? 300}px;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  padding: ${({ theme }) => theme.spacing(3)};
  overflow: auto;
`;

export { Pane };
